import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    businessPartner,
    draftDeleted,
    draftReleased,
    isGuestAuthenticated,
    orderCancelled,
    orders,
    ordersPeriod,
    orderResponse,
    ordersRefresh
} from '../redux/Selectors.js';
import {
    fetchDrafts,
    fetchOrders,
    additionalOrderDatas
} from '../redux/Actions.js';

/**
 * 
 * @param {*} props 
 * @returns 
 */
export const BusinesspartnerService = () => {
    const dispatch = useDispatch();
    const _businessPartner = useSelector((state) => businessPartner(state));
    const _draftReleased = useSelector(state => draftReleased(state));
    const _draftDeleted = useSelector(state => draftDeleted(state));
    const _isGuestAuthenticated = useSelector(state => isGuestAuthenticated(state));
    const _orders = useSelector(state => orders(state));
    const _orderCancelled = useSelector(state => orderCancelled(state));
    const _ordersPeriod = useSelector(state => ordersPeriod(state));
    const _orderResponse = useSelector(state => orderResponse(state));
    const _ordersRefresh = useSelector(state => ordersRefresh(state));
    const [ordersRefreshCount, setOrdersRefreshCount] = useState(1);

    useEffect(() => {
        if (_businessPartner && !_isGuestAuthenticated) {
            dispatch(fetchOrders(_ordersPeriod, ordersRefreshCount));
            setOrdersRefreshCount(ordersRefreshCount + 1);
        }
    }, [_businessPartner, _ordersPeriod, _orderCancelled, _orderResponse, _ordersRefresh]);

    useEffect(() => {
        if (_orders && _businessPartner) {
            let filtered = _orders.filter(e => e._links['expose-status']);
            if (filtered.length) {
                let orderCodes = filtered.map(e => e.orderCode);
                dispatch(additionalOrderDatas(_businessPartner.businessPartnerNo, orderCodes));
            }
        }
    }, [_orders]);

    // useEffect(() => {
    //     if (_businessPartner) {
    //         dispatch(fetchDrafts());
    //     }
    // }, [_businessPartner, _draftReleased, _draftDeleted]);

    return null;
}